import { Box } from '@chakra-ui/react';

import { TextRegular } from 'UiKit/typography';

import AttachmentImage from 'Component/attachment-image';
import UsedStockColumn from 'View/brief-live/component/giveaway-columns/used-stock-column';
import { modalPrizeListText } from 'Const/brief-live/view';

import styles from './styles.module.css';

const UsedStockWrapper = ({ values }) => {
  return <UsedStockColumn value={[values]} />;
};

const tableList = (onOpenPreview) => [
  {
    name: modalPrizeListText.columnPrize,
    key: 'productName',
    position: 'left',
    width: 462,
    component: ({ value, values }) => {
      const images = values?.imagePath ? [{ url: values.imagePath }] : [];
      return (
        <Box className={styles['modal__table--col-prizes']}>
          <AttachmentImage images={images} onOpenPreview={onOpenPreview} />
          <TextRegular className={`${styles['modal__table--col-text']}`}>{value}</TextRegular>
        </Box>
      );
    },
  },
  {
    name: modalPrizeListText.columnStock,
    key: 'totalStock',
    position: 'left',
    width: 90,
    component: ({ value }) => {
      return <TextRegular className={`${styles['modal__table--col-text']}`}>{value}</TextRegular>;
    },
  },
  {
    name: modalPrizeListText.columnUsedStock,
    key: 'usedStock',
    position: 'left',
    width: 200,
    component: ({ values }) => {
      return <UsedStockWrapper values={values} />;
    },
  },
];
export default tableList;
